import { useNavigate } from "react-router-dom";
import "./video.css";

export default function Video({video}) {
    const navigate = useNavigate();
    var date = new Date(0);
    date.setSeconds(video.length);
    var timeStringStartCut = video.length >= 3600? 11: 14;
    var timeString = date.toISOString().substring(timeStringStartCut, 19);
    var views = video.views > 1000 ? `${(video.views / 1000).toFixed(1)}k`: video.views
    var likes = video.likes > 1000 ? `${(video.likes / 1000).toFixed(1)}k`: video.likes
    var dislikes = video.dislikes > 1000 ? `${(video.dislikes / 1000).toFixed(1)}k`: video.dislikes
    var vidName = video.title.length > 60? video.title.substring(0, 60)+"...": video.title
    return <div className="video-frame" onClick={()=>{navigate(`/video?id=${video.id}`)}}>
        <div style={{position: "relative", height: "150pt", width: '100%', backgroundImage: `url(${video.preview})`, backgroundSize: "cover", backgroundPosition: "center"}}></div>
        <p className="video-length">▶ {timeString}</p>
        <h3>{vidName}</h3>
        <h4>{`${video.channel?.title === undefined? "": `${video.channel?.title}: `}👁${views} | 👍${likes} | 👎${dislikes}`}</h4>
    </div>
}